import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SmsService } from 'src/app/services/sms.service';
import { Partido } from 'src/app/models/partido';
import { Quiniela } from 'src/app/models/quiniela';
import { Jugador } from 'src/app/models/jugador';
import { QuinielaJugada } from 'src/app/models/quiniela-jugada';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { PartidosService } from 'src/app/services/partidos.service';
import { JugadorService } from 'src/app/services/jugadores.service';
import { QuinielaJugadaService } from 'src/app/services/quiniela-jugada.service';
import Swal from 'sweetalert2';
import parsePhoneNumber from 'libphonenumber-js';

@Component({
  selector: 'app-llenado-page',
  templateUrl: './llenado-page.component.html',
  styleUrls: ['./llenado-page.component.css']
})
export class LlenadoPageComponent implements OnInit {
  idQuiniela: string;
  isLoading = false;
  quiniela: Quiniela;
  partidos: Array<Partido> = [];
  numero_quiniela: number
  constructor(
    private rutaActiva: ActivatedRoute,
    private QuinielasService: QuinielasService,
    private PartidosService: PartidosService,
    private JugadoresService: JugadorService,
    private QuinielaJugadaService: QuinielaJugadaService,
    private router: Router,
    private toastr: ToastrService,
    private SmsService: SmsService,
  ) { }

  ngOnInit(): void {
    // Obtener por parametro de URL de la Quiniela
    this.idQuiniela = this.rutaActiva.snapshot.params.id;
    console.log(this.idQuiniela)

    // Obtener todos los partidos de esa Quiniela
    this.getAllPartidosByIdQuiniela(this.idQuiniela)

    // Obtener la Quiniela
    this.getQuinielaById();

  }

  // Obtener las Partidos
  getAllPartidosByIdQuiniela(id): void {
    this.isLoading = true;
    this.PartidosService.getAllPartidosByIdQuiniela(id).subscribe((items) => {
      // Setting up partidos
      this.partidos = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Partido)
      );

      // Ordenar los Partidos
      this.partidos.sort((x, y) => +new Date(x.fecha) - +new Date(y.fecha));

      // Terminar cargando
      this.isLoading = false;

      // Imprimiendo los Partidos
      console.log(this.partidos)
    });
  }

  getQuinielaById(): void {
    this.QuinielasService.getQuiniela(this.idQuiniela).subscribe((item) => {
      this.quiniela = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
    });
  }

  onSubmit() {
    // Control para evitar submit en caso que falte algo
    let error = false;

    // Validando los inputs que no esten vacios
    const inputs = ["Nombre", "Apellido", "Email", "Telefono", "Codigo"];
    inputs.map(function (id) {
      document.getElementById(id).classList.remove('is-invalid')
      if ((<HTMLInputElement>document.getElementById(id)).value == '') {
        document.getElementById(id).classList.add('is-invalid')
        error = true
      } else {
        document.getElementById(id).classList.add('is-valid')
      }
    });

    // Validando los inputs que no esten vacios de los partidos
    for (let i = 0; i < this.partidos.length; i++) {
      console.log(this.partidos[i])
      var id = 'Resultado1-' + this.partidos[i].$key
      document.getElementById(id).classList.remove('es-invalido')
      if ((<HTMLInputElement>document.getElementById(id)).value === '' || parseInt((<HTMLInputElement>document.getElementById(id)).value) < 0 || parseInt((<HTMLInputElement>document.getElementById(id)).value) > 9) {
        document.getElementById(id).classList.add('es-invalido')
        error = true
      } else {
        document.getElementById(id).classList.add('es-valido')
      }
      id = 'Resultado2-' + this.partidos[i].$key
      document.getElementById(id).classList.remove('es-invalido')
      if ((<HTMLInputElement>document.getElementById(id)).value === '' || parseInt((<HTMLInputElement>document.getElementById(id)).value) < 0 || parseInt((<HTMLInputElement>document.getElementById(id)).value) > 9) {
        document.getElementById(id).classList.add('es-invalido')
        error = true
      } else {
        document.getElementById(id).classList.add('es-valido')
      }
    }

    if (error) {
      // Enviar el Alerta de que hay un error
      this.toastr.info('¡Revise que este llenando correctamente todos los campos!');
    } else {
      // Ocultar el Formulario
      document.getElementById('Formulario').classList.add('animate__animated', 'animate__faster', 'animate__fadeOutDown');

      // Eliminando espacios, guiones y parentesis de los numeros de telefono
      (<HTMLInputElement>document.getElementById("Telefono")).value = (<HTMLInputElement>document.getElementById("Telefono")).value.replace(/ /g, "");
      (<HTMLInputElement>document.getElementById("Telefono")).value = (<HTMLInputElement>document.getElementById("Telefono")).value.replace("-", "");
      (<HTMLInputElement>document.getElementById("Telefono")).value = (<HTMLInputElement>document.getElementById("Telefono")).value.replace("(", "");
      (<HTMLInputElement>document.getElementById("Telefono")).value = (<HTMLInputElement>document.getElementById("Telefono")).value.replace(")", "");

      // Creación del Objeto Jugador
      const dataJugador: Jugador = {
        id_quiniela: this.idQuiniela,
        nombre: (<HTMLInputElement>document.getElementById("Nombre")).value,
        apellido: (<HTMLInputElement>document.getElementById("Apellido")).value,
        email: (<HTMLInputElement>document.getElementById("Email")).value,
        contacto: (<HTMLInputElement>document.getElementById("Telefono")).value,
        confirmado: false,
        puntaje: 0,
        numero: this.quiniela.numero + 1

      };
      //edito el numero de quiniela
      this.quiniela.numero = this.quiniela.numero + 1
      this.QuinielasService.updateQuiniela(this.quiniela, this.quiniela.$key)


      this.JugadoresService.createJugador(dataJugador).then((res: any) => {

        this.isLoading = false;

        // Obtengo el ID del Jugador creado
        var idJugador = res.f_.path.segments[1];
        console.log(idJugador)

        // Agregar Partidos Aqui
        for (let i = 0; i < this.partidos.length; i++) {
          console.log(this.partidos[i])
          const dataQuinielaJugada: QuinielaJugada = {
            id_quiniela: this.idQuiniela,
            id_jugador: idJugador,
            id_partido: this.partidos[i].$key,
            fecha: this.partidos[i].fecha,
            contrincante1: this.partidos[i].contrincante1,
            resultado1: (<HTMLInputElement>document.getElementById("Resultado1-" + this.partidos[i].$key)).value,
            contrincante2: this.partidos[i].contrincante2,
            resultado2: (<HTMLInputElement>document.getElementById("Resultado2-" + this.partidos[i].$key)).value,
            ppe: 0,
            ppr: 0,
          };
          this.QuinielaJugadaService.createQuinielaJugada(dataQuinielaJugada).then((res) => {
            console.log(res)
          });
        }

        // Redirige a Menu
        this.router.navigate(['pago/' + this.idQuiniela]);

        // Enviar SMS avisando que se registro con exito (CLIENTE)
        var numero = (<HTMLInputElement>document.getElementById("Telefono")).value;
        var texto = "*TuQuinielaYa*: Hola " + (<HTMLInputElement>document.getElementById("Nombre")).value + " su quiniela ha sido guardada con exito, realice el pago y notifique al administrador. \n \n" + this.quiniela.datos_de_pago + "\n \n" + this.quiniela.precio + " " + this.quiniela.moneda + "\n \n*Por favor, no responder este mensaje. Si desea comunicarse con el administrador de su quiniela contacte al siguiente número:* " + this.quiniela.telefono;
        this.SmsService.enviar(numero, texto);


        // Enviar SMS avisando que se registro con exito (ADMINISTRADOR)
        numero = this.quiniela.telefono;
        texto = "*TuQuinielaYa*: Se ha registrado un nuevo participante a la quiniela " + this.quiniela.titulo + ". \n \n Nombre: " + dataJugador.nombre + " \n Apellido: " + dataJugador.apellido + " \n  Telefono: " + dataJugador.contacto + "\n  URL: tuquinielaya.web.app/" + this.quiniela.url + " \n \n *Por favor, no responder este mensaje.*";
        this.SmsService.enviar(numero, texto);

        // Enviar el Alerta
        Swal.fire({
          icon: 'success',
          title: 'Registro completo',
          text: '¡Se ha registrado con exito su Quiniela! Por favor, realice el pago correspondiente para que el administrador proceda a activarla.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#28a745',
        })
      });
    }
  }

  codigoPais() {
    var code = (<HTMLInputElement>document.getElementById("Codigo")).value;
    (<HTMLInputElement>document.getElementById("Telefono")).value = "+" + code;
  }

  llenarAleatorio() {
    Swal.fire({
      title: '¿Estas seguro?',
      text: "Esta funcionalidad llenara con números aleatorios su quiniela. Igualmente, usted podra modificar algun resultados si desea.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // Obtener los input de resultados
        const inputResultados = document.getElementsByClassName("form-control form-control form-control-sm");
        // Recorrer los inputs y llenarlos aletoriamente
        for (let i = 0; i < inputResultados.length; i++) {
          (inputResultados[i] as HTMLInputElement).value = Math.floor((Math.random() * (3 - 0 + 1)) + 0).toString();
        }
      }
    });
  }


  Limpiar(event): void {
    console.log(event.target.id);
    (<HTMLInputElement>document.getElementById(event.target.id)).value = "";
  }

}
